import { InputValidator } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/validators/InputValidator';
export class InputViewModelValidator {
    constructor() {
        this.inputValidator = new InputValidator();
    }
    validate(model) {
        try {
            this.inputValidator.validate(model);
            model.$invalid = false;
        }
        catch (e) {
            model.$invalid = true;
            throw e;
        }
    }
}
